import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import classnames from 'classnames';
import Modal from 'react-responsive-modal';
import {
  TextInput,
  Button,
  Toggle,
  VerticalSpacer
} from '@01_people/ui-library';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withTheme } from 'styled-components';
import ReactTooltip from 'react-tooltip';
import { withTranslation } from 'react-i18next';

// import Api from '../../../utils/api';
import * as ActionCreators from '../../../redux/action';
import SvgEmailAuth from '../../../assets/svg/2fa-email.svg';
import SvgGoogleAuth from '../../../assets/svg/2fa-google.svg';
import SvgSMSAuth from '../../../assets/svg/2fa-sms.svg';
// import SvgU2FAuth from '../../../assets/svg/2fa-u2f.svg';
import SvgIcon from '../../svg-icon';

import TwoFaFormSC from './two-fa-form.styled';
import AppLoader from '../../app-loader';

// TODO: TOTP change after click
class TwoFaForm extends React.PureComponent {
  initialState = {
    smsVerificationCode: '',
    gaVerificationCode: '',
    gaImage: '',
    gaToken: '',
    modal: {
      open: false,
      type: null,
      errors: [],
      loading: false
    }
  };

  constructor(props) {
    super(props);
    this.state = this.initialState;
    this.wrapperRef = React.createRef();
    this.formRef = React.createRef();
  }

  handleCloseModal = () => {
    this.setState(state => ({
      ...state,
      modal: {
        ...state.modal,
        open: false
      }
    }));
  };

  openSMSModalCallback = () => {
    this.setState(state => ({
      ...state,
      smsVerificationCode: '',
      modal: {
        ...state.modal,
        type: 'sms',
        errors: [],
        loading: false
      }
    }));
  };

  handleSmsToggleClick = value => {
    const {
      update2FASettings,
      verifications,
      phoneNumber
      // toggleInfoModal
    } = this.props;

    if (phoneNumber === undefined) {
      return;
    }

    // if we are switching ON and phone is not verified, we are render modal
    // with loading animation
    if (value && !verifications.phone_number) {
      this.setState(
        state => ({
          ...state,
          modal: {
            ...state.modal,
            open: true,
            loading: true
          }
        }),
        // then call update call which will update state of our modal
        () =>
          update2FASettings(
            'sms',
            value,
            this.openSMSModalCallback,
            verifications
          )
      );
      return;
    }
    // if we are switching from ON to OFF, or phone is already verificated, just call backend
    // without rendering modal
    update2FASettings('sms', value, null, verifications);
  };

  handleChangeSMSVerificationCode = value => {
    this.setState(state => ({
      ...state,
      smsVerificationCode: value
    }));
  };

  handleSendSMSVerificationCode = () => {
    const { sendSMSCode, t } = this.props;
    const { smsVerificationCode } = this.state;
    sendSMSCode(smsVerificationCode, {
      ok: () => this.setState(this.initialState),
      nok: e =>
        this.setState(state => ({
          ...state,
          modal: {
            ...state.modal,
            errors: [t(`errors:${e.data.message_code}`)]
          }
        }))
    });
  };

  handleTotpClick = value => {
    const { verifications, update2FASettings } = this.props;

    // if we are switching ON and TOTP is not verified, we are render modal
    // with loading animation
    if (value && !verifications.totp) {
      this.setState(
        state => ({
          ...state,
          modal: {
            ...state.modal,
            open: true,
            loading: true
          }
        }),
        // then call update call which will update state of our modal
        () =>
          update2FASettings(
            'totp',
            value,
            this.openTOTPModalCallback,
            verifications
          )
      );
      return;
    }

    // switch from on to off, just call backend
    update2FASettings('totp', value, this.openTOTPModalCallback, verifications);
  };

  openTOTPModalCallback = (image, token) => {
    this.setState(state => ({
      ...state,
      gaImage: image,
      gaToken: token,
      modal: {
        ...state.modal,
        open: true,
        type: 'totp',
        errors: [],
        loading: false
      }
    }));
  };

  handleChangeTotpCode = value => {
    this.setState(state => ({
      ...state,
      gaVerificationCode: value
    }));
  };

  handleSendTotpVerificationCode = () => {
    const { sendTotpCode, t } = this.props;
    const { gaVerificationCode } = this.state;

    sendTotpCode(gaVerificationCode, {
      ok: () => this.setState(this.initialState),
      nok: e =>
        this.setState(state => ({
          ...state,
          modal: {
            ...state.modal,
            errors: [t(`2fa.totp.${e.data.message_code}`)]
          }
        }))
    });
  };

  handleU2FClick = value => {
    const { verifications, update2FASettings } = this.props;

    // if we are switching from OFF to ON and there isn't previopus initialization
    if (value && !verifications.u2f) {
      this.formRef.current.submit();
    }

    // just update the value
    update2FASettings('u2f', value, null, verifications);
  };

  renderGaImage = () => {
    const {
      gaImage,
      modal: { type }
    } = this.state;
    if (type !== 'totp') return null;
    return <img className="totp-qr-code" src={gaImage} alt="pic" />;
  };

  renderGaAfterText = () => {
    const {
      gaToken,
      modal: { type }
    } = this.state;
    const {t} = this.props;
    if (type !== 'totp') return null;
    return (
      <p className="ga-recovery-code">
        {t('2fa.totp.recoveryCode', {
          code: gaToken
        })}
      </p>
    );
  };

  render() {
    const {
      update2FASettings,
      twoFaSettings: {
        emailVerificationChecked,
        emailVerificationDisabled,
        smsVerificationChecked,
        smsVerificationDisabled,
        totpVerificationChecked,
        totpVerificationDisabled,
        // u2fVerificationChecked,
        // u2fVerificationDisabled
      },
      phoneNumber,
      t,
      available2FA,
    } = this.props;

    const {
      smsVerificationCode,
      gaVerificationCode,
      modal: { type, open: modalIsOpen, errors, loading: modalLoading }
    } = this.state;

    const modalClassNames = classnames(
      'info-modal',
      { 'info-modal--blurred': modalLoading },
      'change-process'
    );

    const icons = {
      checked: t('components:toggle.on'),
      unchecked: t('components:toggle.off')
    };

    return (
      <TwoFaFormSC ref={this.wrapperRef}>
        <h5 className="twofa-heading">{t('2fa.title')}</h5>
        <VerticalSpacer height="10px" />
        <div className="two-fa-form">
          <div className="label-wrapper">
            <div className="svg-wrapper">
              <SvgIcon
                icon={SvgEmailAuth}
                alt="email_icon"
                themed
                active={emailVerificationChecked}
              />
            </div>
            <Toggle
              customClass="twofa-toggle"
              label={t('2fa.email.label')}
              description={t('2fa.email.description')}
              disabled={emailVerificationDisabled || !available2FA.includes('email')}
              checked={emailVerificationChecked}
              onChange={value => update2FASettings('email', value)}
              icons={icons}
            />
          </div>

          <div className="label-wrapper">
            <div className="svg-wrapper">
              <SvgIcon
                icon={SvgSMSAuth}
                alt="sms_icon"
                themed
                active={smsVerificationChecked}
              />
            </div>
            <div
              data-for="SMS"
              data-type="error"
              data-effect="solid"
              data-place="bottom"
              data-offset="{'bottom': 10}"
              data-tip={!phoneNumber ? t('2fa.sms.phoneError') : ''}
              clickable="true"
            >
              <Toggle
                customClass="twofa-toggle"
                label={t('2fa.sms.label')}
                description={t('2fa.sms.description')}
                disabled={smsVerificationDisabled
                    || phoneNumber === undefined
                    || !available2FA.includes('phoneNumber')}
                checked={smsVerificationChecked}
                onChange={this.handleSmsToggleClick}
                icons={icons}
              />
              {phoneNumber === undefined && <ReactTooltip id="SMS" />}
            </div>
          </div>

          <div className="label-wrapper">
            <div className="svg-wrapper">
              <SvgIcon
                icon={SvgGoogleAuth}
                alt="ga_icon"
                themed
                active={totpVerificationChecked}
              />
            </div>
            <Toggle
              customClass="twofa-toggle"
              label={t('2fa.totp.label')}
              description={t('2fa.totp.description')}
              disabled={totpVerificationDisabled || !available2FA.includes('totp')}
              checked={totpVerificationChecked}
              onChange={value => this.handleTotpClick(value)}
              icons={icons}
            />
          </div>

          {/* <div className="label-wrapper">
            <div className="svg-wrapper">
              <SvgIcon
                icon={SvgU2FAuth}
                alt="u2f_icon"
                themed
                active={u2fVerificationChecked}
              />
            </div>
            <Toggle
              customClass="twofa-toggle"
              label={t('2fa.u2f.label')}
              description={t('2fa.u2f.description')}
              disabled={u2fVerificationDisabled}
              checked={u2fVerificationChecked}
              onChange={value => this.handleU2FClick(value)}
            />
            <form
              method="POST"
              action={Api.U2fURL}
              style={{ display: 'none' }}
              ref={this.formRef}
            >
              <input
                type="hidden"
                name="token"
                value={localStorage.getItem('access_token')}
              />
            </form>
          </div> */}
        </div>
        <Modal
          open={modalIsOpen}
          onClose={this.handleCloseModal}
          classNames={{
            modal: modalClassNames,
            overlay: 'info-overlay'
          }}
        >
          <div className={modalLoading ? 'info-modal--blurred' : 'totp-modal'}>
            <SvgIcon
              icon={type === 'sms' ? SvgEmailAuth : SvgGoogleAuth}
              alt="ga_icon"
              themed
              active
            />
            <div className="change-process-modal">
              <h4 className="change-process-modal__heading">
                {type === 'sms'
                  ? t('2fa.modal.heading.sms')
                  : t('2fa.modal.heading.totp')}
              </h4>
              <p className="change-process-modal__description">
                {type === 'sms'
                  ? t('2fa.modal.description.sms')
                  : t('2fa.modal.description.totp')}
              </p>
              {type === 'totp' ? this.renderGaImage() : null}
              <TextInput
                label={
                  type === 'sms'
                    ? t('2fa.modal.input.sms')
                    : t('2fa.modal.input.totp')
                }
                customClass="change-process-modal__input"
                onChange={
                  type === 'sms'
                    ? this.handleChangeSMSVerificationCode
                    : this.handleChangeTotpCode
                }
                defaultValue={
                  type === 'sms' ? smsVerificationCode : gaVerificationCode
                }
                errors={errors}
              />
            </div>
            <div className="button-wrapper">
              <Button
                type="secondary"
                style={{
                  width: '100%',
                  marginTop: '24px',
                  marginBottom: '24px'
                }}
                label={t('2fa.modal.saveButton')}
                onClick={
                  type === 'sms'
                    ? this.handleSendSMSVerificationCode
                    : this.handleSendTotpVerificationCode
                }
              />
            </div>
            {type === 'totp' ? this.renderGaAfterText() : null}
          </div>
          {modalLoading ? <AppLoader size="modal" /> : null}
        </Modal>
      </TwoFaFormSC>
    );
  }
}

TwoFaForm.propTypes = {
  update2FASettings: PropTypes.func.isRequired,
  sendSMSCode: PropTypes.func.isRequired,
  sendTotpCode: PropTypes.func.isRequired,
  twoFaSettings: PropTypes.shape({
    emailVerificationChecked: PropTypes.bool.isRequired,
    emailVerificationDisabled: PropTypes.bool.isRequired,
    smsVerificationChecked: PropTypes.bool.isRequired,
    smsVerificationDisabled: PropTypes.bool.isRequired,
    totpVerificationChecked: PropTypes.bool.isRequired,
    totpVerificationDisabled: PropTypes.bool.isRequired,
    u2fVerificationChecked: PropTypes.bool.isRequired,
    u2fVerificationDisabled: PropTypes.bool.isRequired
  }).isRequired,
  available2FA: PropTypes.arrayOf(PropTypes.string).isRequired,
  verifications: PropTypes.shape({
    totp: PropTypes.bool.isRequired,
    u2f: PropTypes.bool.isRequired,
    phone_number: PropTypes.bool.isRequired
  }).isRequired,
  phoneNumber: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      update2FASettings: ActionCreators.update2FASettings,
      sendSMSCode: ActionCreators.sendPhoneNumVerificationCode,
      sendTotpCode: ActionCreators.sendTotpVerificationCode,
      toggleInfoModal: ActionCreators.toggleInfoModal
    },
    dispatch
  );

const mapStateToProps = state => ({
  twoFaSettings: { ...state.user.auth },
  verifications: state.user.verifications,
  phoneNumber:
    state.user.phone.number === undefined
      ? undefined
      : `+${state.user.phone.prefix}${state.user.phone.number}`,
  available2FA: state.user.available2FA,
});

export default withTranslation('pages')(
  withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(withTheme(TwoFaForm))
  )
);
